import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25px;
    background: transparent;
`;

export const OptionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${props =>
        props.selected === 2 ? 
        'linear-gradient(to left, #85E085 0%, #85E085 50%, #C7C7C7 51%, #C7C7C7 100%)': 
        props.selected === 1 ? 
        '#85E085': 
        props.selected === 0 ? 
        'linear-gradient(to right, #85E085 0%, #85E085 50%, #C7C7C7 51%, #C7C7C7 100%)': 
        '#C7C7C7'};
    gap: 2px;
    border-radius: 20px;
    height: 12px;
    width: 75px;
`;

export const OptionButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${props => (props.selected ? props.isNewValue ? '#4361EE' : '#3C3' : '#C7C7C7')};
    border: none;
    cursor: ${props => (props.selected ? 'auto' : 'pointer')};;
    width: 21px;
    height: 21px;
    text-align: center;
    border-radius: 50%;
    transition: background-color 0.3s;
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    color: #F6F6F6;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 8.728px; /* 58.29% */
    &:hover {
        background-color: ${props => (props.selected ? '#3C3' : '#85E085')};
    }
    @media (min-width: 1281px) {
        width: 21px;
        height: 21px;
        font-size: 15px;
    }
`;